/**
 * Pure helper: translate a WebSocket `close` code into a user-facing message
 * plus a retry policy. Kept dependency-free (no config/api/store imports) so
 * both {@link WsClient} and the live session engine can use it without dragging
 * in the whole app module graph — which also keeps the engine unit-testable
 * without a browser environment.
 *
 * Close codes:
 *   4002 = superseded by another connection from the same user
 *   4408 = server-side session timeout (max duration or idle)
 *   4429 = quota exceeded — do NOT auto-reconnect
 */
export function closeMessage(code: number, reason: string): { msg: string; retry: boolean } {
  const trimmed = reason?.trim();
  switch (code) {
    case 4002: return { msg: "Another device opened a Live session for this account.", retry: false };
    case 4401:
    case 401:  return { msg: "Sign in expired. Sign back in to continue.", retry: false };
    case 4403:
    case 403:  return { msg: "Complete enrollment first so we know your voice.", retry: false };
    case 4429: return { msg: trimmed || "Daily usage limit reached. Contact info@aevum-intel.com if you believe this is in error.", retry: false };
    case 4408: return { msg: trimmed || "Session ended due to inactivity. Tap Connect to start a new one.", retry: true };
    case 1000: return { msg: "", retry: false };
    default:
      return { msg: trimmed ? `Connection closed (${code}): ${trimmed}` : `Connection closed (${code}).`, retry: code >= 1001 && code < 4000 };
  }
}
